import { mrt, output, velocity, uniform, int } from 'three/tsl'
import { motionBlur } from 'three/examples/jsm/tsl/display/MotionBlur.js'

export default class MotionBlur {
	static defaults = { strength: 0.25, samples: 16 }

	constructor(scenePass, options = {}) {
		this.options = { ...MotionBlur.defaults, ...options }
		this.scenePass = scenePass
		this.#build()
	}

	#build() {
		this._strength = uniform(this.options.strength)

		this.scenePass.setMRT(mrt({ output, velocity }))

		this.node = motionBlur(
			this.scenePass.getTextureNode(),
			this.scenePass.getTextureNode('velocity').mul(this._strength),
			int(this.options.samples)
		)
	}

	get strength() {
		return this._strength.value
	}

	set strength(value) {
		this._strength.value = value
	}
}
